<template>
  <div>
    <Card>
        <Header @QueryHandleClick="QueryHandleClick"/>
    </Card>
    <card style="margin-top:1rem">
        <FreightTable :FreightList="FreightList" @NewBuildHandleClick="NewBuildHandleClick" @EditHandleClick="EditHandleClick" @DeleteHandleClick="DeleteHandleClick"/>
        <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
    </card>
    <span></span>
    <Drawer title="物流基础信息维护" v-model="isDrawer" width="80" :mask-closable="false" >
        <Form  :model="FormData" ref="formCustom" :rules="ruleCustom" label-position="left">
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="国家" prop="Country">
                <Input  v-model="FormData.Country" value="FormData.Country" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="省份" prop="Province">
                <Input  v-model="FormData.Province" value="FormData.Province" />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="城市" prop="City">
                <Input  v-model="FormData.City" value="FormData.City" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="区域" prop="Region">
                <Input  v-model="FormData.Region" value="FormData.Region" />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="乡镇">
                <Input  v-model="FormData.Township" value="FormData.Township" />
              </FormItem>
            </Col>
            <Col span="12"></Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="自提价格" prop="SelfMention">
                <Input  type="number" v-model="FormData.SelfMention" value="FormData.SelfMention" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="送货上门价格" prop="Delivery">
                <Input type="number"  v-model="FormData.Delivery" value="FormData.Delivery" />
              </FormItem>
            </Col>
          </Row>
        </Form>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        </div>
      </Drawer>
      <Modal
        v-model="modal"
        title="删除确认"
        @on-ok="SureDeleteHandleClik">
        <p style="color: red">确认删除这条信息吗？</p>
      </Modal>
  </div>
</template>

<script>
import { GetFreightDataApi, ChangeFreightData } from '../../../api/PriceRules'
import Header from './component/FreightHeader.vue'
import FreightTable from './component/FreightTable.vue'
export default {
  name: 'Freight',
  components: {
    Header,
    FreightTable
  },
  data () {
    const validateSelfMention = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入自提价格'))
      } else {
        callback()
      }
    }
    const validateDelivery = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入送货上门价格'))
      } else {
        callback()
      }
    }
    return {
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      isDrawer: false,
      modal: false,
      HeaderList: {
        Country: '',
        Province: '',
        City: '',
        Region: '',
        Township: ''
      },
      FormData: {
        ID: '',
        Country: '',
        Province: '',
        City: '',
        Region: '',
        Township: '',
        SelfMention: '',
        Delivery: ''
      },
      FreightList: [],
      State: 0,
      ruleCustom: {
        Country: [
          { required: true, message: '请输入国家', trigger: 'blur' }
        ],
        Province: [
          { required: true, message: '请输入省份', trigger: 'blur' }
        ],
        City: [
          { required: true, message: '请输入城市', trigger: 'blur' }
        ],
        Region: [
          { required: true, message: '请输入区域', trigger: 'blur' }
        ],
        SelfMention: [{ validator: validateSelfMention, trigger: 'blur' }],
        Delivery: [{ validator: validateDelivery, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetHeaderListHandle(this.HeaderList)
  },
  methods: {
    // 获取物流基础表信息
    GetHeaderListHandle (formItem) {
      GetFreightDataApi({
        Country: formItem.Country,
        Province: formItem.Province,
        City: formItem.City,
        Region: formItem.Region,
        Township: formItem.Township,
        CurrentPage: this.CurrentPage,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.FreightList = res.Data.Table1
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetHeaderListHandle(this.HeaderList)
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetHeaderListHandle(this.HeaderList)
      }
    },
    // 点击新增按钮回调
    NewBuildHandleClick () {
      this.FormData = {
        ID: '',
        Country: '',
        Province: '',
        City: '',
        Region: '',
        Township: '',
        SelfMention: '',
        Delivery: ''
      }
      this.State = 0
      this.isDrawer = true
    },
    // 点击提交按钮回调
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.OkHandleClick()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 提交物流基础信息
    OkHandleClick () {
      ChangeFreightData({
        ID: this.FormData.ID,
        Country: this.FormData.Country,
        Province: this.FormData.Province,
        City: this.FormData.City,
        Region: this.FormData.Region,
        Township: this.FormData.Township,
        SelfMention: this.FormData.SelfMention,
        Delivery: this.FormData.Delivery,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetHeaderListHandle({
            Country: '',
            Province: '',
            City: '',
            Region: '',
            Township: ''
          })
          this.isDrawer = false
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击头部查询按钮回调
    QueryHandleClick (formItem) {
      this.GetHeaderListHandle(formItem)
    },
    // 点击table编辑按钮回调
    EditHandleClick (index) {
      this.State = 1
      this.FormData = {
        ID: this.FreightList[index].ID,
        Country: this.FreightList[index].Country,
        Province: this.FreightList[index].Province,
        City: this.FreightList[index].City,
        Region: this.FreightList[index].Region,
        Township: this.FreightList[index].Township,
        SelfMention: this.FreightList[index].SelfMention,
        Delivery: this.FreightList[index].Delivery
      }
      this.isDrawer = true
    },
    // 点击删除按钮回调
    DeleteHandleClick (index) {
      this.State = 2
      this.FormData.ID = this.FreightList[index].ID
      this.modal = true
      // this.OkHandleClick()
    },
    // 确认删除
    SureDeleteHandleClik () {
      this.OkHandleClick()
    },
    // 弹窗的取消按钮回调
    CancelHandleClick () {
      this.isDrawer = false
    }
  }
}
</script>
